import { useTranslation } from "react-i18next";
import { useLocation } from "wouter";
import { useState } from "react";
import { PageStub } from "../components/ui/PageStub";
import { saveProfile } from "../lib/storage";

export function ProfileSetup() {
  const { t, i18n } = useTranslation();
  const [, navigate] = useLocation();
  const [name, setName] = useState("");
  const [birthdate, setBirthdate] = useState("");
  const canNext = name.trim().length > 0 && birthdate.length > 0;

  return (
    <PageStub title={t("profile.title")} back="/signup">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (!canNext) return;
          saveProfile({
            displayName: name.trim(),
            birthdate,
            locale: i18n.language === "en" ? "en" : "ja",
            isUnlocked: false,
          });
          navigate("/lock");
        }}
        className="flex flex-col gap-4 w-full max-w-xs text-left"
      >
        <label className="flex flex-col gap-1">
          <span className="text-xs opacity-70">{t("profile.displayName")}</span>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder={t("profile.displayNamePlaceholder")}
            className="px-4 py-2 rounded-lg bg-[var(--color-night-deep)] border border-[var(--color-gold)]/40 focus:border-[var(--color-gold)] outline-none"
          />
        </label>
        <label className="flex flex-col gap-1">
          <span className="text-xs opacity-70">{t("profile.birthdate")}</span>
          <input
            type="date"
            value={birthdate}
            onChange={(e) => setBirthdate(e.target.value)}
            className="px-4 py-2 rounded-lg bg-[var(--color-night-deep)] border border-[var(--color-gold)]/40 focus:border-[var(--color-gold)] outline-none"
          />
          <span className="text-[10px] opacity-50">
            {t("profile.birthdateHelp")}
          </span>
        </label>
        <button
          type="submit"
          disabled={!canNext}
          className="mt-2 px-6 py-3 rounded-2xl bg-[var(--color-shu)] text-[var(--color-washi)] disabled:opacity-40"
        >
          {t("profile.next")}
        </button>
      </form>
    </PageStub>
  );
}
